(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selectors = {
      root: '[data-best-sellers]',
      tab: '.best-sellers__tab',
      panel: '.best-sellers__panel',
    };

    const initBestSellers = (container) => {
      if (!container || container.dataset.bestSellersReady === 'true') return;

      const tabs = Array.from(container.querySelectorAll(selectors.tab));
      const panels = Array.from(container.querySelectorAll(selectors.panel));

      if (!tabs.length || !panels.length) return;

      const setActiveTab = (index) => {
        tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === index;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach((panel, panelIndex) => {
          const isActive = panelIndex === index;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          setActiveTab(Number(tab.dataset.tabIndex || 0));
        });
      });

      container.dataset.bestSellersReady = 'true';

      const initialIndex = tabs.findIndex((tab) => tab.classList.contains('is-active'));
      setActiveTab(initialIndex >= 0 ? initialIndex : 0);
    };

    const initAllBestSellers = (scope = document) => {
      scope.querySelectorAll(selectors.root).forEach(initBestSellers);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllBestSellers(), { once: true });
    } else {
      initAllBestSellers();
    }

    document.addEventListener('shopify:section:load', (event) => initAllBestSellers(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-persistent-cart"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ctr-header-banners"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("alpine:init", () => {
    Alpine.data("headerBanners", function () {
        return {
            init() {
                const banners = this.$el.querySelectorAll('[data-banner]');
                banners.forEach(banner => {
                    const destination = banner.dataset.destinationSelector;
                    const destinationElements = document.querySelectorAll(destination);

                    if (banner && destinationElements) {
                        destinationElements.forEach(destinationElement => {
                            destinationElement.appendChild(banner.cloneNode(true));
                        });
                    }
                });
            }
        }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  class HeroSliderComponent extends HTMLElement {
    connectedCallback() {
      this.init();
      this.boundSectionLoad = this.handleSectionLoad.bind(this);
      document.addEventListener('shopify:section:load', this.boundSectionLoad);
      document.addEventListener('shopify:block:select', this.handleBlockSelect.bind(this));
      document.addEventListener('shopify:block:deselect', this.handleBlockDeselect.bind(this));
    }

    disconnectedCallback() {
      this.clearTimer();
      document.removeEventListener('shopify:section:load', this.boundSectionLoad);
      document.removeEventListener('visibilitychange', this.boundVisibility);
    }

    init() {
      this.track = this.querySelector('.hero-slider__track');
      this.slides = Array.from(this.querySelectorAll('.hero-slider__slide'));
      this.dots = Array.from(this.querySelectorAll('.hero-slider__dot'));
      this.prevBtn = this.querySelector('.hero-slider__arrow--prev');
      this.nextBtn = this.querySelector('.hero-slider__arrow--next');
      this.playPauseBtn = this.querySelector('.hero-slider__play-pause');
      this.currentIndex = 0;
      this.autoplayEnabled = this.dataset.autoplay === 'true' && this.slides.length > 1;
      this.loop = this.dataset.loop === 'true';
      this.pauseOnHover = this.dataset.pauseOnHover === 'true';
      this.isPaused = false;
      this.timer = null;

      if (window.Shopify && window.Shopify.designMode) {
        this.autoplayEnabled = false;
      }

      if (this.track) this.track.style.transform = 'translateX(0%)';

      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
      if (this.playPauseBtn) this.playPauseBtn.addEventListener('click', () => this.togglePlay());
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => { this.pause(true); this.goTo(i); }));

      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') this.next();
        if (e.key === 'ArrowLeft') this.prev();
      });

      this.setupSwipe();

      if (this.pauseOnHover) {
        this.addEventListener('mouseenter', () => this.pause(false));
        this.addEventListener('mouseleave', () => {
          if (!this.isPaused) this.resume();
        });
      }

      this.boundVisibility = () => {
        if (document.hidden) {
          this.clearTimer();
        } else if (!this.isPaused) {
          this.scheduleNext();
        }
      };
      document.addEventListener('visibilitychange', this.boundVisibility);

      this.setAttribute('data-initialized', 'true');

      if (this.autoplayEnabled) {
        this.scheduleNext();
        this.restartDotProgress();
      }
    }
    
    setupSwipe() {
      if (!this.track || this.slides.length <= 1) return;

      let startX = 0;
      let startY = 0;
      let isSwiping = false;

      const onStart = (e) => {
        const point = e.touches ? e.touches[0] : e;
        startX = point.clientX;
        startY = point.clientY;
        isSwiping = true;
      };

      const onMove = (e) => {
        if (!isSwiping) return;
        const point = e.touches ? e.touches[0] : e;
        const deltaX = point.clientX - startX;
        const deltaY = point.clientY - startY;

        if (Math.abs(deltaX) > Math.abs(deltaY) && e.cancelable) {
          e.preventDefault();
        }
      };

      const onEnd = (e) => {
        if (!isSwiping) return;
        isSwiping = false;

        const point = e.changedTouches ? e.changedTouches[0] : e;
        const deltaX = point.clientX - startX;
        const deltaY = point.clientY - startY;

        if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;

        this.pause(false);

        if (deltaX < 0) {
          this.next();
        } else {
          this.prev();
        }

        if (!this.isPaused) this.resume();
      };

      this.track.addEventListener('touchstart', onStart, { passive: true });
      this.track.addEventListener('touchmove', onMove, { passive: false });
      this.track.addEventListener('touchend', onEnd);
      this.track.addEventListener('touchcancel', () => { isSwiping = false; });
    }

    handleBlockSelect(e) {
      const idx = this.slides.findIndex((s) => s.dataset.blockId === e.detail.blockId);
      if (idx > -1) {
        this.pause(false);
        this.goTo(idx);
      }
    }

    handleBlockDeselect() {
      if (window.Shopify && window.Shopify.designMode) return;
      if (!this.isPaused) this.resume();
    }

    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    }

    scheduleNext() {
      this.clearTimer();
      if (!this.autoplayEnabled || this.isPaused || this.slides.length <= 1) return;
      const duration = parseInt(this.slides[this.currentIndex].dataset.duration, 10) || 5000;
      this.timer = setTimeout(() => this.next(), duration);
    }

    goTo(index) {
      if (!this.slides[index] || index === this.currentIndex) return;
      const current = this.slides[this.currentIndex];
      const next = this.slides[index];

      current.classList.remove('is-active');
      current.setAttribute('aria-hidden', 'true');
      next.classList.add('is-active');
      next.removeAttribute('aria-hidden');

      if (this.track) this.track.style.transform = `translateX(-${index * 100}%)`;

      if (this.dots[this.currentIndex]) {
        this.dots[this.currentIndex].classList.remove('is-active');
        this.dots[this.currentIndex].setAttribute('aria-selected', 'false');
      }
      if (this.dots[index]) {
        this.dots[index].classList.add('is-active');
        this.dots[index].setAttribute('aria-selected', 'true');
      }

      this.currentIndex = index;
      this.scheduleNext();
      this.restartDotProgress();
    }

    next() {
      let nextIndex = this.currentIndex + 1;
      if (nextIndex >= this.slides.length) {
        if (!this.loop) {
          this.pause(false);
          return;
        }
        nextIndex = 0;
      }
      this.goTo(nextIndex);
    }

    prev() {
      let prevIndex = this.currentIndex - 1;
      if (prevIndex < 0) {
        if (!this.loop) return;
        prevIndex = this.slides.length - 1;
      }
      this.goTo(prevIndex);
    }

    pause(userInitiated) {
      this.isPaused = true;
      this.clearTimer();
      const activeFill = this.dots[this.currentIndex]?.querySelector('.hero-slider__dot-ring-fill');
      if (activeFill) activeFill.style.animationPlayState = 'paused';
      if (userInitiated) this.setPlayPauseUI(false);
    }

    resume() {
      this.isPaused = false;
      this.setPlayPauseUI(true);
      this.scheduleNext();
      this.restartDotProgress();
    }

    togglePlay() {
      if (this.isPaused) this.resume();
      else this.pause(true);
    }

    restartDotProgress() {
      if (!this.autoplayEnabled) return;
      const duration = parseInt(this.slides[this.currentIndex].dataset.duration, 10) || 5000;
      this.dots.forEach((dot, i) => {
        const fill = dot.querySelector('.hero-slider__dot-ring-fill');
        if (!fill) return;
        fill.style.animation = 'none';
        fill.style.animationPlayState = '';
        if (i === this.currentIndex) {
          // eslint-disable-next-line no-unused-expressions
          void fill.offsetWidth;
          fill.style.animation = `hero-slider-dot-progress ${duration}ms linear forwards`;
        }
      });
    }

    setPlayPauseUI(isPlaying) {
      if (!this.playPauseBtn) return;
      const iconPause = this.playPauseBtn.querySelector('.icon-pause');
      const iconPlay = this.playPauseBtn.querySelector('.icon-play');
      if (iconPause) iconPause.hidden = !isPlaying;
      if (iconPlay) iconPlay.hidden = isPlaying;
      this.playPauseBtn.setAttribute('aria-pressed', String(!isPlaying));
      this.playPauseBtn.setAttribute('aria-label', isPlaying ? 'Pause slideshow' : 'Play slideshow');
    }
  }

  if (!customElements.get('hero-slider-component')) {
    customElements.define('hero-slider-component', HeroSliderComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
